import { motion } from 'framer-motion';
import { X, Cookie, Shield, BarChart3 } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieBanner = ({ onAccept, onReject }) => {
  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-revo-paper border border-revo-border shadow-2xl">
        <div className="p-6 md:p-8">
          {/* Header */}
          <div className="flex items-start justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-revo-orange/10 flex items-center justify-center">
                <Cookie className="w-6 h-6 text-revo-orange" />
              </div>
              <div>
                <h3 className="font-barlow text-xl font-bold text-white uppercase tracking-wide">
                  Utilizzo dei Cookie
                </h3>
                <p className="text-gray-500 text-sm">
                  Gestiamo i tuoi dati con trasparenza
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <p className="text-gray-400 text-sm leading-relaxed mb-6">
            Questo sito utilizza cookie tecnici necessari al funzionamento e cookie analitici per 
            migliorare la tua esperienza. Puoi scegliere di accettare tutti i cookie o solo quelli 
            essenziali.{' '}
            <Link to="/cookie-policy" className="text-revo-orange hover:underline">
              Leggi la Cookie Policy
            </Link>
          </p>

          {/* Cookie Types */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div className="flex items-start gap-3 p-4 bg-revo-subtle border border-revo-border">
              <Shield className="w-5 h-5 text-green-500 mt-0.5" />
              <div>
                <p className="text-white text-sm font-medium">Cookie Essenziali</p>
                <p className="text-gray-500 text-xs">Sempre attivi - Necessari per il funzionamento</p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 bg-revo-subtle border border-revo-border">
              <BarChart3 className="w-5 h-5 text-blue-500 mt-0.5" />
              <div>
                <p className="text-white text-sm font-medium">Cookie Analitici</p>
                <p className="text-gray-500 text-xs">Opzionali - Per analisi anonime del traffico</p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onAccept}
              className="flex-1 bg-revo-orange text-white px-6 py-3 font-barlow font-bold uppercase tracking-widest text-sm hover:bg-revo-orange-dark transition-all duration-300 hover:shadow-[0_0_20px_rgba(255,102,0,0.3)]"
              data-testid="cookie-accept-all"
            >
              Accetta Tutti
            </button>
            <button
              onClick={onReject}
              className="flex-1 bg-transparent border border-revo-border text-white px-6 py-3 font-barlow font-bold uppercase tracking-widest text-sm hover:border-revo-orange hover:text-revo-orange transition-all duration-300"
              data-testid="cookie-reject"
            >
              Solo Essenziali
            </button>
          </div>

          {/* Legal Reference */}
          <p className="text-gray-600 text-xs text-center mt-6">
            Titolare del trattamento: <span className="text-gray-400">Revogreen srl</span> - 
            P.IVA 05121010234 - Via Alberto Dominutti, 6 - 37135 Verona (VR)
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default CookieBanner;
